// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Germany from '../_raw/flag/icon_flag_germany.png';

export default () => <img src={Germany} alt="Germany" />;
